import { render, staticRenderFns } from "./GridVcDemo.vue?vue&type=template&id=751036f5&scoped=true&"
import script from "./GridVcDemo.vue?vue&type=script&lang=js&"
export * from "./GridVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./GridVcDemo.vue?vue&type=style&index=0&id=751036f5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751036f5",
  null
  
)

export default component.exports